import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowLeft, Calendar, Construction, Wrench } from 'lucide-react';

const EventsPlaceholder = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-slate-900/80 border-b border-slate-700">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-white">
            Çankaya
          </Link>
          <nav className="flex gap-6 items-center">
            <Link to="/" className="text-slate-300 hover:text-white transition-colors">
              Home
            </Link>
            <a href="https://ogulcan.cankaya.xyz" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors">
              Portfolio
            </a>
          </nav>
        </div>
      </header>

      {/* Content */}
      <section className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl text-center">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-500/20 rounded-full mb-6 border border-orange-500/30">
              <Calendar className="h-10 w-10 text-orange-400" />
            </div>
            <h1 className="text-5xl font-bold text-white mb-4">
              Stories & Events
            </h1>
            <div className="w-20 h-1 bg-orange-500 mx-auto mb-8"></div>
          </div>

          <Card className="p-12 bg-slate-800/50 backdrop-blur-sm border-slate-700 shadow-xl">
            <Construction className="h-16 w-16 text-orange-400 mx-auto mb-6" />
            <h2 className="text-2xl font-semibold text-white mb-4">
              Under Construction
            </h2>
            <p className="text-lg text-slate-400 mb-8 max-w-2xl mx-auto">
              This section will feature stories and experiences from technical events, conferences, 
              and memorable moments from the DevOps and cloud infrastructure community. Check back soon for updates!
            </p>
            
            <div className="flex items-center justify-center gap-3 text-slate-500 mb-8">
              <Wrench className="h-5 w-5" />
              <span className="text-sm">Coming Soon</span>
              <Wrench className="h-5 w-5" />
            </div>

            <Link to="/">
              <Button 
                size="lg" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg group transition-all duration-300"
              >
                <ArrowLeft className="mr-2 h-5 w-5 group-hover:-translate-x-1 transition-transform" />
                Back to Home
              </Button>
            </Link>
          </Card>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 bg-slate-950 text-slate-500 border-t border-slate-800">
        <div className="container mx-auto text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} Ahmet Oğulcan Çankaya. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default EventsPlaceholder;
